import Modal from './Modal';

interface QRCodeErrorModalProps {
  isOpen: boolean;
  error: string | null;
  onClose: () => void;
}

const QRCodeErrorModal = ({ isOpen, error, onClose }: QRCodeErrorModalProps) => {
  if (!isOpen || !error) return null;

  return (
    <Modal
      onClose={onClose}
      isBackgroundTransparent={true}
    >
      <h2 className="text-lg font-semibold mb-3">เกิดข้อผิดพลาด</h2>
      <p className="mb-4">{error}</p>
      <button
        onClick={onClose}
        className="bg-indigo-500 text-white px-4 py-2 rounded hover:bg-indigo-600"
      >
        ปิด
      </button>
    </Modal>
  );
};

export default QRCodeErrorModal;
